/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const reviewerSummaryRowSchema = z.object({
  userId: z.string(),
  approved: z.number(),
  rejected: z.number(),
  total: z.number(),
  approvalRate: z.number().nullable(),
  avgDecisionMs: z.number().nullable(),
  lastActiveAt: z.number(),
});

export const reviewerPerformanceSummaryV1DataSchema = z.object({
  rows: z.array(reviewerSummaryRowSchema),
  fromUnix: z.number(),
  toUnix: z.number(),
});

export type IReviewerSummaryRow = z.infer<typeof reviewerSummaryRowSchema>;
export type IReviewerPerformanceSummaryV1Data = z.infer<
  typeof reviewerPerformanceSummaryV1DataSchema
>;

export const getReviewerPerformanceSummaryV1ResponseSchema = createApiResponseSchema(
  reviewerPerformanceSummaryV1DataSchema,
) as z.ZodSchema<IAPI<IReviewerPerformanceSummaryV1Data>>;

export type IGetReviewerPerformanceSummaryV1Response = IAPI<IReviewerPerformanceSummaryV1Data>;
